import constants from "../Utils/constants";

const initialState = {
  isSendOtpLoading: false,
  isVerifyOtpLoading: false,
  otpVerified: false,
};

const otpReducer = (state = initialState, action) => {
  switch (action.type) {
    // SEND OTP
    case constants.SEND_OTP_REQUEST:
      return {
        ...state,
        isSendOtpLoading: true,
      };

    case constants.SEND_OTP_SUCCESS:
      return {
        ...state,
        isSendOtpLoading: false,
      };

    case constants.SEND_OTP_FAILURE:
      return {
        ...state,
        isSendOtpLoading: false,
      };

    // VERIFY OTP
    case constants.VERIFY_OTP_REQUEST:
      return {
        ...state,
        isVerifyOtpLoading: true,
      };

    case constants.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isVerifyOtpLoading: false,
        otpVerified: true,
      };

    case constants.VERIFY_OTP_FAILURE:
      return {
        ...state,
        isVerifyOtpLoading: false,
        otpVerified: false,
      };

    case "REMOVING_USER_CREDENTIALS":
      return initialState;

    default:
      return state;
  }
};

export default otpReducer;